import styled from 'styled-components'
import { Icon } from '@gate/gui'
import { Flex } from '@mantine/core'

export const ArrowIconStyled = styled(Icon)<{ background: string }>`
  color: #fff;
  width: 16px;
  height: 16px;
  font-size: 12px;
  border-radius: 2px;
  background: ${({ background }) => background};
`

export const MarketListItemStyled = styled(Flex)`
  width: 100%;
  height: 48px;
  padding-bottom: 2px;
  box-sizing: border-box;
  cursor: pointer;

  .price-coin-item {
    width: 100%;
    padding: 12px;

    &:hover {
      background: var(--color-neutral-2);
    }
  }
`
